export const REFERRAL_REWARD_CARD_TEST_ID = 'referral-reward-card'
export const REFERRAL_REWARD_IMAGE_TEST_ID = 'referral-reward-image'
export const REFERRAL_REWARD_RARITY_TEST_ID = 'referral-reward-rarity'
export const REFERRAL_REWARD_CLAIM_BUTTON_TEST_ID = 'referral-reward-claim-button'
export const REFERRAL_REWARD_CHECK_ICON_TEST_ID = 'referral-reward-check-icon'
export const REFERRAL_REWARD_LOCK_ICON_TEST_ID = 'referral-reward-lock-icon'

export const CLAIM_REWARD_MODAL_TEST_ID = {
  title: 'claim-reward-modal-title',
  description: 'claim-reward-modal-description',
  emailInput: 'claim-reward-modal-email-input',
  submitButton: 'claim-reward-modal-submit-button',
  errorMessage: 'claim-reward-modal-error-message'
} as const
